<template>
  <b-row>
    <b-col
      md="8"
      lg="8"
      offset-lg="2"
    >
      <b-card
        no-body
        class="card-payment"
      >
        <b-card-body>
          <!-- form -->
          <b-form>
            <validation-observer
              ref="settingsform"
              tag="form"
            >
              <b-row>
                <b-col sm="12">
                  <validation-provider
                    #default="{ errors }"
                    name="Module"
                    rules="required"
                  >
                    <b-form-group
                      label="Module"
                      label-for="module"
                    >
                      <v-select
                        id="module"
                        v-model="selectedModule"
                        :options="moduleOptions"
                        :reduce="option => option.value"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col sm="12">
                  <validation-provider
                    #default="{ errors }"
                    name="Maximum Client Id length"
                    rules="required"
                  >
                    <b-form-group
                      label="Client Id"
                      label-for="client_id"
                    >
                      <b-form-input
                        id="client_id"
                        v-model="setting_values.client_id"
                        type="text"
                        :placeholder="$t('DEBTIA_CLIENT_ID')"
                        :maxlength="maxClientIdLength"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col sm="12">
                  <b-form-group
                    :label="$t('DEBTIA_SECRET')"
                    label-for="secret"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Maximum Secret length"
                      rules="required"
                    >
                      <b-form-input
                        id="secret"
                        v-model="setting_values.secret"
                        type="text"
                        :placeholder="$t('DEBTIA_SECRET')"
                        :maxlength="maxSecretLength"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </validation-observer>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              block
              variant="primary"
              @click="postSettingValues"
            >
              Save
            </b-button>
          </b-form>
          <!--/ form -->
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BFormInput, BButton, BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import { required } from '@validations'
import axios from '@axios'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      setting_values: {
        id: '',
        client_id: '',
        secret: '',
        module: '',
      },
      required,
      maxClientIdLength: 20,
      maxSecretLength: 40,
      selectedModule: 'communication',
      moduleOptions: [
        { label: 'Debt Cases', value: 'debt-cases' },
        { label: 'Communication', value: 'communication' },
      ],
    }
  },
  watch: {
    selectedModule: {
      deep: true,
      handler(newValue) {
        this.settingsData(newValue)
      },
    },
  },
  created() {
    this.settingsData(this.selectedModule)
  },
  methods: {
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    settingsData(selectedModule) {
      axios.get('settings/get', { params: { module: selectedModule } }).then(response => {
        const settingValues = this.setting_values
        const settingDetails = response.data.data
        if (settingDetails === null) {
          settingValues.id = ''
          settingValues.module = ''
          settingValues.client_id = ''
          settingValues.secret = ''
        } else {
          settingValues.id = settingDetails.id
          settingValues.module = settingDetails.module
          settingValues.client_id = settingDetails.client_id
          settingValues.secret = settingDetails.secret
        }
      })
    },
    postSettingValues() {
      return new Promise((resolve, reject) => {
        this.$refs.settingsform.validate().then(success => {
          if (success) {
            this.setting_values.company_id = JSON.parse(localStorage.getItem('userData')).data.id
            this.setting_values.module = this.selectedModule
            axios.post('settings/save', { ...this.setting_values }).then(response => {
              console.log(response)
              this.makeSuccessToast()
              resolve(true)
            })
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
